import { jsx as a } from "react/jsx-runtime";
import { XmarkCircle as s, CheckCircle as c, WarningTriangle as h, InfoCircle as w, MoreVert as m, MoreHoriz as d, List as u, ViewGrid as f, SortDown as p, Filter as g, RefreshDouble as k, Upload as C, Download as x, OpenInWindow as v, Link as A, LockSlash as S, Lock as y, EyeClosed as L, Eye as M, EditPencil as N, Trash as b, Page as D, Folder as I, Home as U, Bell as H, Clock as P, Calendar as R, Mail as z, Star as E, Heart as T, User as W, Settings as F, Minus as G, Plus as V, Sparks as X, Code as j, Terminal as B, Github as O, ArrowUpRight as $, HalfMoon as q, SunLight as J, Menu as K, Search as Q, Copy as Y, Xmark as Z, Check as _, NavArrowUp as rr, NavArrowDown as or, NavArrowLeft as er, NavArrowRight as nr, ArrowDown as tr, ArrowUp as ir, ArrowLeft as lr, ArrowRight as ar } from "iconoir-react";
export * from "iconoir-react";
import { cn as sr } from "../../utils/cn.js";
const cr = {
  "arrow-right": ar,
  "arrow-left": lr,
  "arrow-up": ir,
  "arrow-down": tr,
  "chevron-right": nr,
  "chevron-left": er,
  "chevron-down": or,
  "chevron-up": rr,
  check: _,
  x: Z,
  copy: Y,
  search: Q,
  menu: K,
  sun: J,
  moon: q,
  external: $,
  github: O,
  terminal: B,
  code: j,
  sparkles: X,
  plus: V,
  minus: G,
  settings: F,
  user: W,
  heart: T,
  star: E,
  mail: z,
  calendar: R,
  clock: P,
  bell: H,
  home: U,
  folder: I,
  file: D,
  trash: b,
  edit: N,
  eye: M,
  "eye-off": L,
  lock: y,
  unlock: S,
  link: A,
  "external-link": v,
  download: x,
  upload: C,
  refresh: k,
  filter: g,
  sort: p,
  grid: f,
  list: u,
  "more-horizontal": d,
  "more-vertical": m,
  info: w,
  warning: h,
  success: c,
  error: s
}, hr = {
  xs: "w-3 h-3",
  sm: "w-4 h-4",
  md: "w-5 h-5",
  lg: "w-6 h-6",
  xl: "w-8 h-8"
}, wr = {
  xs: 12,
  sm: 16,
  md: 20,
  lg: 24,
  xl: 32
};
function fr({ name: o, size: r = "md", className: i, ...l }) {
  const e = cr[o];
  if (!e)
    return console.warn(`Icon "${o}" not found`), null;
  const n = typeof r == "number", t = n ? r : wr[r];
  return /* @__PURE__ */ a(
    e,
    {
      width: t,
      height: t,
      strokeWidth: 1.5,
      className: sr(!n && hr[r], i),
      "aria-hidden": "true",
      ...l
    }
  );
}
export {
  fr as Icon
};
//# sourceMappingURL=Icon.js.map
